import React, { useEffect, useState } from 'react'
import { Box, Button, Card, Grid, Typography } from "@mui/material";
import DoubleArrowIcon from '@mui/icons-material/DoubleArrow';
import { useDispatch } from 'react-redux';
import Breadcrumbs from "../../../components/breadcrumbs";
import CreationDialog from '../../../components/dialog';
import CutoffLunchMenuTable from '../../../components/admin/portalDesign/cutoffLunchMenu';
import CutoffLunchMenuCreation from '../../../components/admin/portalDesign/cutoffLunchMenu/cutoffLunchMenuCreation';
import { getDropDownWatcher } from '../../../redux/actionCreators/admin/employeeManagement';
import { getMenuItemMasterWatcher } from '../../../redux/actionCreators/admin/menuItemMaster';
import { getMealDropdownWatcher, getMenuMasterWatcher } from '../../../redux/actionCreators/admin/menuMaster';

const CutoffLunchMenu = () => {

    const dispatch = useDispatch();

    const [open, setOpen] = useState(false)
    const [editRow, setEditRow] = useState(null)

    useEffect(() => {
        dispatch(getDropDownWatcher())
        dispatch(getMenuItemMasterWatcher({ ACTION: 'SELECT' }))
        dispatch(getMenuMasterWatcher({ ACTION: 'GridSELECT' }))
        dispatch(getMealDropdownWatcher())
    }, [dispatch])

    const handleAdd = () => {
        setEditRow(null)
        setOpen(true)
    }

    const handleEdit = (rowData) => {
        setEditRow(rowData)
        setOpen(true)
    }

    const handleClose = (value) => {
        setOpen(value)
        if (!value) setEditRow(null)
    }

    return (
        <>
            <Box p='30px'>
                <Breadcrumbs content={["Portal Design", "Cutoff Lunch Menu"]} />
                <Box p='15px 0'>
                    <Typography variant='t24_700' > Cutoff Lunch Menu </Typography>
                </Box>

                <Card style={{ boxShadow: (theme) => `0px 12px 23px ${theme.palette.grey[200]}` }}>
                    <Grid container spacing={3} sx={{ padding: '30px', pb: '20px' }} >
                        <Grid item lg={6} xs={6} sx={{ justifyContent: 'left' }}>
                            <div>
                                <Typography variant='t20_600'>Cutoff Lunch Menu</Typography>
                            </div>
                        </Grid>
                        <Grid item xs={6} sx={{ justifyContent: 'right', display: 'flex' }}>
                            <Button variant='contained' endIcon={<DoubleArrowIcon />} sx={{ width: '197px', height: '50px' }} onClick={handleAdd} >
                                <Typography variant='t16_500' >
                                    Add Cutoff
                                </Typography>
                            </Button>
                        </Grid>
                        <Grid item xs={12}>
                            <CutoffLunchMenuTable onEdit={handleEdit} />
                        </Grid>
                    </Grid>
                </Card>
            </Box>

            {open &&
                <CreationDialog open={open} setOpen={handleClose} >
                    <CutoffLunchMenuCreation setOpen={handleClose} editData={editRow} />
                </CreationDialog >
            }
        </>
    )
}

export default CutoffLunchMenu;
